import { AxiosRequestConfig } from 'axios'

const getUsers = (): AxiosRequestConfig => ({
  url: '/users?statistics=true',
  method: 'GET',
})

const getUsersDto = (query: string): AxiosRequestConfig => ({
  url: `/users/dto?${query}`,
  method: 'GET',
})

const getUserPollResult = (userId: number): AxiosRequestConfig => ({
  url: `/users/${userId}/poll-result`,
  method: 'GET',
})

export { getUsers, getUsersDto, getUserPollResult }
